import { useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { WEB_ROUTES } from "../routes/web-routes";
import {
  FaLinkedin,
  FaXTwitter,
  FaFacebook,
  FaChevronDown,
} from "react-icons/fa6";

export default function Header() {
  const location = useLocation();
  const [aboutOpen, setAboutOpen] = useState(false);
  const [newsOpen, setNewsOpen] = useState(false);

  const isAboutActive =
    location.pathname === WEB_ROUTES.ABOUT ||
    location.pathname === WEB_ROUTES.LEADERSHIP;
  const isNewsActive =
    location.pathname === WEB_ROUTES.NEWS ||
    location.pathname === WEB_ROUTES.FEATURED_IN;

  return (
    <header className="bg-white relative">
      <nav
        className={`container mx-auto flex items-center justify-between pt-4 md:px-0 px-8 ${
          WEB_ROUTES.HOME !== location.pathname ? "pb-5" : "pb-0"
        }`}
        aria-label="Global"
      >
        <div className="flex lg:flex-1">
          <NavLink to={WEB_ROUTES.HOME} className="inline-block">
            <span className="sr-only">Nant Power Project Logo</span>
            <img
              className="h-20 -mt-3"
              src="/images/nant-power-logo-colour.svg"
              alt="Nant Power Project Logo"
            />
          </NavLink>
        </div>

        <div className="hidden lg:flex lg:gap-x-8 relative">
          <NavLink
            to={WEB_ROUTES.HOME}
            className="leading-6 font-medium text-[#808080] hover:text-[#0070b9] content-center"
          >
            Home
            <div className={``}></div>
            {WEB_ROUTES.HOME === location.pathname && (
              <div className={``}></div>
            )}
          </NavLink>

          <div
            className="relative content-center"
            onMouseEnter={() => setAboutOpen(true)}
            onMouseLeave={() => setAboutOpen(false)}
          >
            <NavLink
              to={WEB_ROUTES.ABOUT}
              className={`flex items-center gap-1 leading-6 font-medium hover:text-[#0070b9] ${isAboutActive ? "text-[#0070b9]" : "text-[#808080]"}`}
            >
              About
              <FaChevronDown
                size={11}
                className={`transition-transform duration-200 ${aboutOpen ? "rotate-180" : ""}`}
              />
            </NavLink>
            {aboutOpen && (
              <div className="absolute top-full left-0 mt-0 pt-1 w-44 bg-white shadow-lg rounded-md py-1 z-50">
                <NavLink
                  to={WEB_ROUTES.ABOUT}
                  className="block px-4 py-2 text-base font-medium text-[#808080] hover:text-[#0070b9] hover:bg-gray-50"
                >
                  About Us
                </NavLink>
                <NavLink
                  to={WEB_ROUTES.LEADERSHIP}
                  className="block px-4 py-2 text-base font-medium text-[#808080] hover:text-[#0070b9] hover:bg-gray-50"
                >
                  Leadership
                </NavLink>
              </div>
            )}
          </div>

          <NavLink
            to={WEB_ROUTES.PROJECT}
            className="leading-6 font-medium text-[#808080] hover:text-[#0070b9] content-center"
          >
            Project
            <div className={``}></div>
            {WEB_ROUTES.PROJECT === location.pathname && (
              <div className={``}></div>
            )}
          </NavLink>

          <NavLink
            to={WEB_ROUTES.IMPACT}
            className="leading-6 font-medium text-[#808080] hover:text-[#0070b9] content-center"
          >
            Impact
            <div className={``}></div>
            {WEB_ROUTES.IMPACT === location.pathname && (
              <div className={``}></div>
            )}
          </NavLink>

          <NavLink
            to={WEB_ROUTES.GALLERY}
            className="leading-6 font-medium text-[#808080] hover:text-[#0070b9] content-center"
          >
            Gallery
            <div className={``}></div>
            {WEB_ROUTES.GALLERY === location.pathname && (
              <div className={``}></div>
            )}
          </NavLink>

          <NavLink
            to={WEB_ROUTES.CAREERS}
            className="leading-6 font-medium text-[#808080] hover:text-[#0070b9] content-center"
          >
            Careers
            <div className={``}></div>
            {WEB_ROUTES.CAREERS === location.pathname && (
              <div className={``}></div>
            )}
          </NavLink>

          <div
            className="relative content-center"
            onMouseEnter={() => setNewsOpen(true)}
            onMouseLeave={() => setNewsOpen(false)}
          >
            <NavLink
              to={WEB_ROUTES.NEWS}
              className={`flex items-center gap-1 leading-6 font-medium hover:text-[#0070b9] ${isNewsActive ? "text-[#0070b9]" : "text-[#808080]"}`}
            >
              News & Media
              <FaChevronDown
                size={11}
                className={`transition-transform duration-200 ${newsOpen ? "rotate-180" : ""}`}
              />
            </NavLink>
            {newsOpen && (
              <div className="absolute top-full left-0 mt-0 pt-1 w-52 bg-white shadow-lg rounded-md py-1 z-50">
                <NavLink
                  to={WEB_ROUTES.NEWS}
                  className="block px-4 py-2 text-base font-medium text-[#808080] hover:text-[#0070b9] hover:bg-gray-50"
                >
                  Latest News & Media
                </NavLink>
                <NavLink
                  to={WEB_ROUTES.FEATURED_IN}
                  className="block px-4 py-2 text-base font-medium text-[#808080] hover:text-[#0070b9] hover:bg-gray-50"
                >
                  Featured in
                </NavLink>
              </div>
            )}
          </div>

          <NavLink
            to={WEB_ROUTES.CONTACT}
            className="leading-6 font-medium text-[#808080] hover:text-[#0070b9] content-center"
          >
            Contact Us
            <div className={``}></div>
            {WEB_ROUTES.CONTACT === location.pathname && (
              <div className={``}></div>
            )}
          </NavLink>
        </div>
        <div className="hidden lg:flex lg:gap-x-2 relative ml-8">
          <a
            className="flex items-center gap-1"
            href="https://www.facebook.com/profile.php?id=61578106486775"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaFacebook size={20} color="#808080" />
          </a>
          <a
            className="flex items-center gap-1"
            href="https://x.com/Nant_Power"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaXTwitter size={20} color="#808080" />
          </a>
          <a
            className="flex items-center gap-1"
            href="https://www.linkedin.com/company/nant-power/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <FaLinkedin size={20} color="#808080" />
          </a>

          <img
            className="h-8 ml-5"
            src="/images/sierra-leone-flag.png"
            alt="Country Flag"
          />
        </div>

        <div className="hidden lg:flex items-center justify-between gap-x-8"></div>

        <div className="flex items-center gap-6">
          <div className="block lg:hidden">
            <label
              className="relative z-40 cursor-pointer px-3 py-6"
              htmlFor="mobile-menu"
            >
              <input className="peer hidden" type="checkbox" id="mobile-menu" />
              <div className="relative z-50 block h-[1px] w-7 bg-black bg-transparent content-[''] before:absolute before:top-[-0.35rem] before:z-50 before:block before:h-full before:w-full before:bg-black before:transition-all before:duration-200 before:ease-out before:content-[''] after:absolute after:right-0 after:bottom-[-0.35rem] after:block after:h-full after:w-full after:bg-black after:transition-all after:duration-200 after:ease-out after:content-[''] peer-checked:bg-transparent before:peer-checked:top-0 before:peer-checked:w-full before:peer-checked:rotate-45 before:peer-checked:transform after:peer-checked:bottom-0 after:peer-checked:w-full after:peer-checked:-rotate-45 after:peer-checked:transform"></div>
              <div className="fixed inset-0 z-40 hidden h-full w-full bg-black/50 backdrop-blur-sm peer-checked:block">
                &nbsp;
              </div>
              <div className="fixed top-0 right-0 z-40 h-full w-full translate-x-full overflow-y-auto overscroll-y-none transition duration-500 peer-checked:translate-x-0">
                <div className="float-right min-h-full w-[85%] bg-white px-10 py-6 shadow-2xl z-50">
                  <NavLink className="inline-block" to={WEB_ROUTES.HOME}>
                    <img
                      className="w-40 h-auto"
                      src="/images/nant-power-logo-colour.svg"
                      alt="Nant Power Project Logo"
                    />
                  </NavLink>
                  <menu className="mt-8 mb-8 flex flex-col space-y-4 text-heading">
                    <li className="whitespace-nowrap pb-1 font-semibold">
                      <NavLink
                        to={WEB_ROUTES.HOME}
                        className="nav-link-item text-[#808080] hover:text-[#0070b9]"
                      >
                        Home
                      </NavLink>
                    </li>
                    <li className="pb-1 font-semibold">
                      <button
                        className="flex items-center gap-1 text-[#808080] hover:text-[#0070b9] w-full"
                        onClick={() => setAboutOpen((o) => !o)}
                      >
                        About
                        <FaChevronDown
                          size={11}
                          className={`transition-transform duration-200 ${aboutOpen ? "rotate-180" : ""}`}
                        />
                      </button>
                      {aboutOpen && (
                        <ul className="mt-2 ml-4 flex flex-col space-y-2">
                          <li>
                            <NavLink
                              className="nav-link-item text-[#808080] hover:text-[#0070b9]"
                              to={WEB_ROUTES.ABOUT}
                            >
                              About Us
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="nav-link-item text-[#808080] hover:text-[#0070b9]"
                              to={WEB_ROUTES.LEADERSHIP}
                            >
                              Leadership
                            </NavLink>
                          </li>
                        </ul>
                      )}
                    </li>
                    <li className="whitespace-nowrap pb-1 font-semibold hover:text-[#0070b9]">
                      <NavLink
                        to={WEB_ROUTES.PROJECT}
                        className="nav-link-item text-[#808080]"
                      >
                        Project
                      </NavLink>
                    </li>

                    <li className="whitespace-nowrap pb-1 font-semibold hover:text-[#0070b9]">
                      <NavLink
                        to={WEB_ROUTES.IMPACT}
                        className="nav-link-item text-[#808080]"
                      >
                        Impact
                      </NavLink>
                    </li>
                    <li className="pb-1 font-semibold">
                      <button
                        className="flex items-center gap-1 text-[#808080] hover:text-[#0070b9] w-full"
                        onClick={() => setNewsOpen((o) => !o)}
                      >
                        News & Media
                        <FaChevronDown
                          size={11}
                          className={`transition-transform duration-200 ${newsOpen ? "rotate-180" : ""}`}
                        />
                      </button>
                      {newsOpen && (
                        <ul className="mt-2 ml-4 flex flex-col space-y-2">
                          <li>
                            <NavLink
                              className="nav-link-item text-[#808080] hover:text-[#0070b9]"
                              to={WEB_ROUTES.NEWS}
                            >
                              Latest News & Media
                            </NavLink>
                          </li>
                          <li>
                            <NavLink
                              className="nav-link-item text-[#808080] hover:text-[#0070b9]"
                              to={WEB_ROUTES.FEATURED_IN}
                            >
                              Featured in
                            </NavLink>
                          </li>
                        </ul>
                      )}
                    </li>
                    <li className="whitespace-nowrap pb-1 font-semibold hover:text-[#0070b9]">
                      <NavLink
                        to={WEB_ROUTES.GALLERY}
                        className="nav-link-item text-[#808080]"
                      >
                        Gallery
                      </NavLink>
                    </li>
                    <li className="whitespace-nowrap pb-1 font-semibold hover:text-[#0070b9]">
                      <NavLink
                        to={WEB_ROUTES.CAREERS}
                        className="nav-link-item text-[#808080]"
                      >
                        Careers
                      </NavLink>
                    </li>
                    <li className="whitespace-nowrap pb-1 font-semibold hover:text-[#0070b9]">
                      <NavLink
                        to={WEB_ROUTES.CONTACT}
                        className="nav-link-item text-[#808080]"
                      >
                        Contact Us
                      </NavLink>
                    </li>
                  </menu>
                  <div className="flex lg:gap-x-2 relative gap-x-3">
                    <a
                      className="flex items-center"
                      href="https://www.facebook.com/profile.php?id=61578106486775"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebook size={30} color="#808080" />
                    </a>
                    <a
                      className="flex items-center"
                      href="https://x.com/Nant_Power"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaXTwitter size={30} color="#808080" />
                    </a>
                    <a
                      className="flex items-center"
                      href="https://www.linkedin.com/company/nant-power/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedin size={30} color="#808080" />
                    </a>
                  </div>
                </div>
              </div>
            </label>
          </div>
        </div>
      </nav>
      {WEB_ROUTES.HOME !== location.pathname && (
        <div className="border-b border-gray-200 md:px-0 px-8md:px-0 px-8"></div>
      )}
    </header>
  );
}
